module.exports = __webpack_public_path__ + "img/open.bd346097.svg";